class FAQSection {
  constructor(section) {
    this.section = section;
    this.tabs = this.section.querySelectorAll('.section-faq__tab');
    this.panels = this.section.querySelectorAll('.section-faq__panel');
    this.init();
  }

  init() {
    this.setupTabs();
    this.setupAccordions();
  }

  setupTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const tabIndex = tab.getAttribute('data-tab-index');
        this.switchTab(tabIndex);
      });
    });
  }

  switchTab(index) {
    // Remove active state from all tabs
    this.tabs.forEach((tab) => {
      tab.classList.remove('section-faq__tab--active');
    });

    // Remove active state from all panels
    this.panels.forEach((panel) => {
      panel.classList.remove('section-faq__panel--active');
    });

    // Add active state to selected tab and panel
    const selectedTab = this.section.querySelector(`[data-tab-index="${index}"]`);
    const selectedPanel = this.section.querySelector(`[data-panel-index="${index}"]`);

    if (selectedTab) {
      selectedTab.classList.add('section-faq__tab--active');
    }

    if (selectedPanel) {
      selectedPanel.classList.add('section-faq__panel--active');
    }
  }

  setupAccordions() {
    this.panels.forEach((panel) => {
      const questions = panel.querySelectorAll('.section-faq__question');

      questions.forEach((question) => {
        question.addEventListener('click', () => {
          const item = question.closest('.section-faq__item');
          const isActive = item.classList.contains('section-faq__item--active');

          // Close all items in this panel
          const allItems = panel.querySelectorAll('.section-faq__item');
          allItems.forEach((i) => {
            i.classList.remove('section-faq__item--active');
          });

          // Toggle current item if it wasn't active
          if (!isActive) {
            item.classList.add('section-faq__item--active');
          }
        });
      });
    });
  }
}

// Initialize all FAQ sections
document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('[data-section-type="w-faq"]');
  faqSections.forEach((section) => {
    new FAQSection(section);
  });
});

// Shopify theme editor support
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-faq"]');
    if (section) {
      new FAQSection(section);
    }
  });
}
